import { RouteType } from "types/RouteType";
// import jobDashboardRoute from "./JobDashboard/jobDashboard.Route";
import projectDashboardRoute from "./ProjectDashboard/ProjectDashboard.Route";
import jobPanelCountsRoute from "./JobPanelCounts/jobPanelCounts.Route";
import jobGanttChartRoute from "./JobGanttChart/JobGanttChart.Route";
// import pcsRoute from "./PCS/pcs.Route";

const projectManagementRoutesList: RouteType[] = [
    // ...jobDashboardRoute,
    ...projectDashboardRoute,
    jobPanelCountsRoute,
    ...jobGanttChartRoute,
    // pcsRoute,
];

export default projectManagementRoutesList;
